import laffMoreLogo from './../images/laff-more-logo.svg'

const SUPPORT_LINK = 'https://support.laff.com/support/home';

const header = {
    data: new Map([
        ['menuLinks', 
            [
                {
                    type:`internal-link`,
                    href: `/schedule`,
                    label: `Schedule`,
                },
                {
                    type:`internal-link`,
                    href: `/find-us`,
                    label: `Find Us`,
                },
            ]
        ],
        ['logoItems', 
            [
                {
                    image: {
                        url: laffMoreLogo,
                        width: 300,
                        height: 119,
                        altText: `Laff More logo, go to Laff More home page`,
                    },
                    href: `/laffmore`,
                    target: '_blank',
                    height: 2.2,
                    baselineAdjustment: -0.9,
                    text: 'Laff More',
                },
            ]
        ]
    ])
}

const footer = {
    data: new Map([
        ['navSections', 
            [
                {
                    "title": "Site Navigation",
                    "links": [
                        {
                            "href": "/",
                            "type": "internal-link",
                            "label": "Home"
                        },
                        {
                            "href": "/schedule",
                            "type": "internal-link",
                            "label": "Schedule"
                        },
                        {
                            "href": "/find-us",
                            "type": "internal-link",
                            "label": "Find Us"
                        }
                    ],
                    "classname": "footer-nav"
                },
                {
                    "title": "Networks",
                    "links": [
                        {
                            "href": "https://laff.com",
                            "type": "internal-link",
                            "label": "Laff"
                        },
                        {
                            "href": "https://laff.com/laffmore",
                            "type": "external-link",
                            "label": "Laff More"
                        },
                    ],
                    "classname": "footer-nav"
                },
                {
                    "title": "Privacy & Terms",
                    "links": [
                        {
                            "href": "https://scripps.com/privacy-policy",
                            "type": "external-link",
                            "label": "Privacy Policy"
                        },
                        {
                            "href": "https://scripps.com/user-agreement/",
                            "type": "extrenal-link",
                            "label": "Terms of Use"
                        },
                        {
                            "href": "http://scripps.com/privacy-center",
                            "type": "external-link",
                            "label": "Privacy Center"
                        },
                        {
                            "href": "#",
                            "type": "internal-link",
                            "label": "Do Not Sell My Info",
                            "classname": "privacy-preferences-trigger",
                        },
                    ],
                    "classname": "footer-nav"
                },
                {
                    "title": "Information",
                    "links": [
                        {
                            "href": "https://support.laff.com/support/solutions",
                            "type": "external-link",
                            "label": "Help/FAQs"
                        },
                        {
                            "href": "https://support.laff.com/support/home",
                            "type": "external-link",
                            "label": "Contact Us"
                        },
                    ],
                    "classname": "footer-nav"
                }
            ]
        ],
        ['socialLinks',
            [
                {
                    platform: 'facebook',
                    url: 'https://www.facebook.com/lafftvnetwork?fref=ts',
                },
                {
                    platform: 'twitter',
                    url: 'https://twitter.com/laff',
                },
                {
                    platform: 'instagram',
                    url: 'https://www.instagram.com/lafftv',
                },
                {
                    platform: 'tiktok',
                    url: 'https://www.tiktok.com/@laff.tv',
                },
            ]
        ],
    ])  
}

const laffmoreFooter = {
    data: new Map([
        ['navSections', 
            [
                {
                    "title": "Site Navigation",
                    "links": [
                        {
                            "href": "/",
                            "type": "internal-link",
                            "label": "Laff Home"
                        },
                    ],
                    "classname": "footer-nav"
                },
                {
                    "title": "Privacy & Terms",
                    "links": [
                        {
                            "href": "https://scripps.com/privacy-policy",
                            "type": "external-link",
                            "label": "Privacy Policy"
                        },
                        {
                            "href": "https://scripps.com/user-agreement/",
                            "type": "external-link",
                            "label": "Terms of Use"
                        },
                        {
                            "href": "http://scripps.com/privacy-center",
                            "type": "external-link",
                            "label": "Privacy Center"
                        },
                        {
                            "href": "#",
                            "type": "internal-link",
                            "label": "Do Not Sell My Info",
                            "classname": "privacy-preferences-trigger",
                        },
                    ],
                    "classname": "footer-nav"
                },
                {
                    "title": "Information",
                    "links": [
                        {
                            "href": SUPPORT_LINK,
                            "type": "external-link",
                            "label": "Contact Us"
                        },
                        {
                            "href": "https://support.laff.com/support/solutions",
                            "type": "external-link",
                            "label": "Frequently Asked Questions"
                        },
                    ],
                    "classname": "footer-nav"
                }
            ]
        ],
        ['socialLinks',
            [
                {
                    platform: 'facebook',
                    url: 'https://www.facebook.com/lafftvnetwork?fref=ts',
                },
                {
                    platform: 'twitter',
                    url: 'https://twitter.com/laff',
                },
                {
                    platform: 'instagram',
                    url: 'https://www.instagram.com/lafftv',
                },
                {
                    platform: 'tiktok',
                    url: 'https://www.tiktok.com/@laff.tv',
                },
            ]
        ],
    ])  
}

const resources = new Map([
    ['header', header],
    ['footer', footer],
    ['laffmore-footer', laffmoreFooter],
])

export {
    resources,
    SUPPORT_LINK,
}